import React from 'react';
import InnerPageBanner from '../components/InnerPageBanner';
import { Box, Container, Typography, Grid, Stack, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const ContactUs = () => {
    const greenColor = '#1cc2a3';

    return (
        <Box>
            <InnerPageBanner title="Contact Us" />pm

            {/* Main Content Section */}
            <Container sx={{ py: { xs: 4, md: 8 } }}>
                <Grid container spacing={{ xs: 3, md: 6 }}>
                    {/* Left Column - Map */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                height: { xs: 300, md: 500 },
                                borderRadius: 2,
                                overflow: 'hidden',
                                boxShadow: 3
                            }}
                        >
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31112.643636832978!2d77.54313188242423!3d12.902548036340177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae150d0d7ce973%3A0x7fc5f990bcd62349!2sIndia%20Post%20-%20Jayaprakash%20Narayan%20Nagara%20Sub%20Post%20Office!5e0!3m2!1sen!2sin!4v1771314691137!5m2!1sen!2sin" width="600" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </Box>
                    </Grid>

                    {/* Right Column - Contact Details */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontWeight: 700,
                                    color: 'text.primary',
                                    mb: 1,
                                    fontSize: { xs: '1.5rem', md: '2.125rem' }
                                }}
                            >
                                Get In Touch
                            </Typography>
                            <Box sx={{ width: { xs: 50, md: 60 }, height: { xs: 3, md: 4 }, bgcolor: greenColor, mb: { xs: 2, md: 4 } }} />

                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'text.secondary',
                                    mb: { xs: 3, md: 4 },
                                    lineHeight: 1.8,
                                    fontSize: { xs: '0.875rem', md: '1rem' }
                                }}
                            >
                                We'd love to hear from you! Whether you have questions about our products,
                                need a quote, or want to discuss your project, our team is ready to help.
                            </Typography>

                            <Stack spacing={{ xs: 2, md: 3 }}>
                                {/* Phone and Email Row */}
                                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'flex-start', justifyContent: 'space-between', gap: { xs: 2, md: 0 } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <PhoneIcon sx={{ color: greenColor, fontSize: { xs: 20, md: 28 }, mr: { xs: 1.5, md: 2 }, mt: 0.5 }} />
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, fontSize: { xs: '0.95rem', md: '1.25rem' } }}>
                                                Phone
                                            </Typography>
                                            <Link href="tel:+919845374571" underline="none" sx={{ color: 'text.secondary', '&:hover': { color: greenColor } }}>
                                                <Typography variant="body1" sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }}>+91 98453 74571</Typography>
                                            </Link>
                                            <Link href="tel:+916366663480" underline="none" sx={{ color: 'text.secondary', '&:hover': { color: greenColor } }}>
                                                <Typography variant="body1" sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }}>+91 63666 63480</Typography>
                                            </Link>
                                        </Box>
                                    </Box>

                                    {/* Email */}
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <EmailIcon sx={{ color: greenColor, fontSize: { xs: 20, md: 28 }, mr: { xs: 1.5, md: 2 }, mt: 0.5 }} />
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, fontSize: { xs: '0.95rem', md: '1.25rem' } }}>
                                                Email
                                            </Typography>
                                            <Link
                                                href="mailto:info@4mhenterprises.com"
                                                underline="none"
                                                sx={{ color: 'text.secondary', '&:hover': { color: greenColor }, cursor: 'pointer' }}
                                            >
                                                <Typography variant="body1" sx={{ fontSize: { xs: '0.875rem', md: '1rem' }, wordBreak: 'break-word' }}>info@4mhenterprises.com</Typography>
                                            </Link>
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Address and Business Hours Row */}
                                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'flex-start', justifyContent: 'space-between', gap: { xs: 2, md: 0 } }}>

                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <LocationOnIcon sx={{ color: greenColor, fontSize: { xs: 20, md: 28 }, mr: { xs: 1.5, md: 2 }, mt: 0.5 }} />
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, fontSize: { xs: '0.95rem', md: '1.25rem' } }}>
                                                Address
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, fontSize: { xs: '0.875rem', md: '1rem' } }}>
                                                Ground Floor, No.44, C1, <br /> 4th Main Road, Jaraganahalli,  <br />  Ilyas Nagar, J.P. Nagar Post, Bangalore - 560078, Karnataka, India
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Business Hours */}
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <AccessTimeIcon sx={{ color: greenColor, fontSize: { xs: 20, md: 28 }, mr: { xs: 1.5, md: 2 }, mt: 0.5 }} />
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, fontSize: { xs: '0.95rem', md: '1.25rem' } }}>
                                                Business Hours
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: { xs: '0.875rem', md: '1rem' } }}>
                                                Monday - Saturday: 9:00 AM - 7:00 PM
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: { xs: '0.875rem', md: '1rem' } }}>
                                                Sunday: Closed
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </Container >
        </Box >
    );
};

export default ContactUs;
